import React from "react";
import Icon from "../shared/icons/Icon";
import classNames from "classnames";
import { isActive } from "../app/aside/utils";
import useInnerNav from "./useInnerNav";

interface linkProps {
  title: string;
  to: string;
}

export interface ReportInnerNavProps {
  title: string;
  links: linkProps[];
}

const ReportInnerSubNav = ({ title, links }: ReportInnerNavProps) => {
  const [close, setClose] = useInnerNav();

  const handleCloseNav = (e: string) => {
    if (close.includes(e)) {
      return setClose(close.filter((key) => key !== e));
    }
    return setClose([...close, e]);
  };

  const subNavs = links.map((link, i) => (
    <li key={i}>
      <a href={link.to} className={classNames({ active: isActive([link.to]) })}>
        {link.title}
      </a>
    </li>
  ));

  return (
    <li>
      <hr />
      <div className={"nav-sub-header"} onClick={() => handleCloseNav(title)}>
        <h4>
          {title}
          {!close.includes(title) ? <Icon icon={"chevron down"} /> : <Icon icon={"chevron up"} />}
        </h4>
      </div>
      {!close.includes(title) && <ul className={"nav-sub collapse show"}>{subNavs}</ul>}
    </li>
  );
};

export default ReportInnerSubNav;
